import { createUseStyles } from 'react-jss'
import { ThemeProps } from 'themes';

export const useStyles = createUseStyles(({ nextButton, button }: ThemeProps) => ({
    title: {
        textAlign: 'left',
        marginBottom: '16px',

        '@media (min-width: 768px)' : {
            fontSize: '20px',
            lineHeight: '28px',
            textAlign: 'center',
            marginBottom: '40px'
        }
    },
    subtitle: {
        fontWeight: 400,
        textAlign: 'left',
        margin: '16px 0 12px',

        '@media (min-width: 768px)' : {
            fontSize: '20px',
            lineHeight: '28px',
            textAlign: 'center',
            margin: '16px 0 56px',
        }
    },
    iconWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        margin: '32px 0 0',

        '@media (min-width: 768px)' : {
            margin: '80px 0 -40px'
        },

        '@media (max-width: 320px)' : {
            '& img': {
                width: '100%'
            },
        }
    },
    continueButtonWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    continueButton: {
        ...button.button,
        ...nextButton.nextButton,

        '&:active': {
            ...nextButton.nextButtonHovered,
        }
    },
    link: {
        textDecoration: 'none',
        color: '#FFFFFF'
    },
    changeAnswersButton: {
        ...nextButton.nextButton,
        margin: '-12px 0 24px',
        background: 'none',
        color: '#EB731A',

        '@media (min-width: 768px)' : {
            margin: '-16px 0 24px',
        },
    },
    '@media (hover: hover)': {
        continueButton: {
            "&:hover": {
                ...nextButton.nextButtonHovered,
            }
        }
    }
}));
